import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { ViewService } from '../view.service';

declare var $: any;


@Component({
  selector: 'app-ad-building',
  templateUrl: './ad-building.component.html',
  styleUrls: ['../ad-default.component.scss']
})
export class AdBuildingComponent extends AdUtils implements OnInit {

  unitFocus = null;
  settimeout = null;

  constructor(
    private route: ActivatedRoute,
    srs: AdSearchService,
    gs: GeneralService,
    vs : ViewService) {
    super(srs, gs, vs);

    if(this.route.snapshot.paramMap.get('id'))
      this.data = {
        friendlyTitle: this.route.snapshot.paramMap.get('id'),
        ad: this.route.snapshot.data['type']
      };    
  }

  ngOnInit(){
    this.setDefault();
  }
  
  eventCallback(e) { }

  setDefault() {
    this.setDefaultUtils();
    
  }

  setBlockTabActive(i){
    this.blockTabActive = i;
    $('.dropdown-toggle').dropdown('toggle');
  }

  setUnitFocus(unit = null, output = false){
    this.unitFocus = unit;
    if(this.settimeout)
      clearTimeout(this.settimeout);

    if(unit){

      let el = $((output? '.tableprice' : '.unitmap')+'.col-content.scroll');
      let elUnit = el.find('#unit'+unit);

      if(!!elUnit?.length){
        let top = elUnit.offset().top + el.scrollTop() - (output? 220 : 0);
        if(top <= el.outerHeight() - 150 && !output)
          top = 0;
        
        //this.settimeout = setTimeout(function(){          el.animate({ scrollTop: top }, 100 , 'linear');        },150); TODO
      }
    }
  }

  setUnitSelected(unit){
    this.unitTypeSelected = {
        type: this.info.blockTypes[unit.blockId].filter(item => item.id == unit.blockTypeId)[0], 
        unit: unit
    };
  }

  unitSelected(unit) {
    this.unitTypeSelected = unit;
    setTimeout(function () {
      $('#unitDetailProposal').modal({show:true, backdrop:false});
    }, 100);
  }

  changeShowAvailable(ev: any) {
    this.showAvailable = !this.showAvailable;
  }

  changeShowPromotion(ev: any) {
    this.showPromotion = !this.showPromotion;
  }

  proposalClose(event){
    this.unitTypeSelected = false;
  }

}